/**
 * Lolli Lifting homepage redesign (2A) — email capture.
 * Inline client-side format validation on top of the server-side
 * validation Shopify's customer form already does (form.errors /
 * form.posted_successfully? in the section, both fully functional
 * without this script). This just catches an obviously malformed
 * address before the round trip and gives immediate feedback.
 */
(() => {
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('.lolli-email__form').forEach((form) => {
    const input = form.querySelector('input[type="email"]');
    const errorEl = form.querySelector('.lolli-email__inline-error');
    if (!input || !errorEl) return;

    const setError = (message) => {
      input.classList.toggle('lolli-input--error', Boolean(message));
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
      errorEl.textContent = message || '';
    };

    input.addEventListener('input', () => {
      if (input.classList.contains('lolli-input--error')) setError('');
    });

    form.addEventListener('submit', (event) => {
      const value = input.value.trim();
      if (value && !EMAIL_PATTERN.test(value)) {
        event.preventDefault();
        setError('Enter a valid email address.');
        input.focus();
      }
    });
  });
})();
